import React, { useEffect, useState, useMemo } from "react"
import { useNavigate } from "react-router-dom"
import PropTypes from "prop-types"
import { isEmpty } from "lodash"
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  UncontrolledTooltip,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Button,
} from "reactstrap"
import Switch from "react-switch"

import DeleteModal from "../../../components/Common/DeleteModal"

import { EmailId, PhoneNo, Role } from "./UserCustCol"
import {
  deleteSapUser,
  getSapUserList,
  editUserStatus,
} from "helpers/UAM/user.helper"
import TableContainerV1 from "components/Common/TableContainerV1"
import ToastDialog from "components/Common/ToastDialog"
import CommonDialog from "components/Common/CommonDialog"
import { getUser, isPermission } from "common/utility"

const Offsymbol = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        fontSize: 12,
        color: "#fff",
        paddingRight: 10,
      }}
    >
      {" "}
      Inactive
    </div>
  )
}

const OnSymbol = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        fontSize: 12,
        color: "#fff",
        paddingLeft: 4,
      }}
    >
      {" "}
      Active
    </div>
  )
}

const TableActionsComponent = (props, handleChange) => {
  const [checked, setChecked] = useState(props.isActive)
  const newObj = {}
  for (const key in props) {
    if (props[key] !== null) {
      newObj[key] = props[key]
    }
  }
  useEffect(() => {
    setChecked(props.isActive)
  }, [props])
  return (
    <UncontrolledDropdown>
      <DropdownToggle tag="a" className="card-drop">
        <Switch
          uncheckedIcon={<Offsymbol />}
          checkedIcon={<OnSymbol />}
          className="me-1 mb-sm-8 mb-2"
          onColor="#344fa0"
          width={80}
          onChange={() => {
            newObj.isActive = !props.isActive
            props.isActive = !props.isActive
            setChecked(newObj.isActive)
            handleChange(newObj)
          }}
          checked={checked}
        />
      </DropdownToggle>
    </UncontrolledDropdown>
  )
}

const UamUsers = () => {

  document.title = "Users List | DMS";
  const navigate = useNavigate();
  const [toastInfo, setToastInfo] = useState({ showToast: false });
  const [userList, setUserList] = useState([]);
  const [filters, setFilters] = useState({isActive: ""})
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageCount: 0,
    totalRecords: 0,
  })
  const [currentPage, setCurrentPage] = useState(1)
  const [pageSize, setPageSize] = useState(10)
  const [searchValue, setSearchValue] = useState("")
  const [columnId, setColumnId] = useState("id")
  const [deleteModalInfo, setDeleteModalInfo] = useState({}) //for delete modal
  const [sortingOrderStatus, setSortingOrderStatus] = useState("desc")
  const [sortingOptions, setSortingOptions] = useState({
    column: "id",
    isAsc: false,
    optionalColumn: ["Action", "Active", "userStatus", "region", "roleName"],
  })
  const [showCommonDialog, setShowCommonDialog] = useState({ isShow: false })

  const [uploadPermission, setUploadPermission] = useState(false)

  const {roleName}= JSON.parse(localStorage.getItem("user"))

  const [userRoleName, setUserRoleName] = useState(roleName)

  useEffect(() => {
    checkPermissions()
  }, [])

  const handleUserView = userInfo => {
    const enCodedId = btoa(userInfo.id)
    navigate(`/${userRoleName}/users/view/${enCodedId}`)
  }

  const handleDeleteUser = userInfo => {
    setDeleteModalInfo(userInfo)
  }

  const handleEditUser = userInfo => {
    const enCodedId = btoa(userInfo.id)
    navigate(`/${userRoleName}/users/edit/${enCodedId}`)
  }

  const deleteUser = async () => {
    const { id } = deleteModalInfo
    const response = await deleteSapUser({ id })
    if (response.status) {
      setToastInfo({
        message: response.message,
        showToast: true,
        role: "success",
      })
      setDeleteModalInfo({})
      getUserList()
    } else {
      setToastInfo({
        message: response.message,
        showToast: true,
        role: "error",
      })
    }
  }

  // Customber Column
  const columns = useMemo(
    () => [
      {
        Header: "Employee Name",
        accessor: "firstName",
        filterable: true,
        Cell: cellProps => {
          return (
            <div className="">
              {cellProps?.row?.original?.firstName}{" "}
              <span>{cellProps?.row?.original?.lastName}</span>
            </div>
          )
        },
      },
      {
        Header: "Employee Id",
        accessor: "userId",
        filterable: true,
        Cell: cellProps => {
          return <div className="">{cellProps?.row?.original?.userId} </div>
        },
      },
      {
        Header: "Email",
        accessor: "email",
        filterable: true,
        Cell: cell => {
          return cell.value ? cell.value : ""
        },
      },
      {
        Header: "Mobile Number",
        accessor: "mobileNo",
        filterable: true,
        Cell: cell => {
          return cell.value ? cell.value : ""
        },
      },
      {
        Header: "Role",
        accessor: "roleName",
        // filterable: true,
        Cell: cell => {
          return cell.value ? cell.value : "-"
        },
      },
      {
        Header: "Region",
        accessor: "region",
        filterable: true,
        Cell: cellProps => {
          return cellProps?.row?.original?.region.join(",") || "-"
        },
      },
      {
        Header: "User Status",
        accessor: "userStatus",
        Cell: cellProps => {
          const rowData = cellProps.row.original
          return TableActionsComponent(rowData, handleChange)
        },
      },
      {
        Header: "Action",
        Cell: cellProps => {
          return (
            <UncontrolledDropdown>
              <DropdownToggle tag="a" className="card-drop">
                <i className="mdi mdi-dots-horizontal font-size-18"></i>
              </DropdownToggle>

              <DropdownMenu className="dropdown-menu-end">
                <DropdownItem
                  onClick={() => {
                    const userData = cellProps.row.original
                    handleUserView(userData)
                  }}
                >
                  <i
                    className="mdi mdi-eye font-size-16 text-success me-1"
                    id="viewtooltip"
                  ></i>
                  View
                  <UncontrolledTooltip placement="top" target="viewtooltip">
                    View
                  </UncontrolledTooltip>
                </DropdownItem>
                <DropdownItem
                  className="d-flex align-items-center"
                  onClick={() => {
                    const userData = cellProps.row.original
                    handleEditUser(userData)
                  }}
                >
                  <faEdit
                    className="fas fa-edit font-size-16 text-success me-1"
                    id="edittooltip"
                  ></faEdit>
                  Edit
                  <UncontrolledTooltip placement="top" target="edittooltip">
                    Edit
                  </UncontrolledTooltip>
                </DropdownItem>
                <DropdownItem
                  className="d-flex align-items-center"
                  onClick={() => {
                    const userData = cellProps.row.original
                    handleDeleteUser(userData)
                  }}
                >
                  <i
                    className="fas fa-trash font-size-16 text-danger me-1"
                    id="deletetooltip"
                  ></i>
                  Delete
                  <UncontrolledTooltip placement="top" target="deletetooltip">
                    Delete
                  </UncontrolledTooltip>
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          )
        },
      },
    ],
    []
  )

  const getUserList = async bodyData => {
    const response = await getSapUserList(bodyData)
    if (response.status) {
      if(response.data.data.length >0){
        setUserList(response.data.data)
        const { totalItems, totalPages, currentPage } = response.data
        setPagination({
          pageIndex: currentPage,
          pageCount: totalPages,
          totalRecords: totalItems,
        })
      }else{
        setPagination({ pageIndex: 0, pageCount: 0, totalRecords: 0 })
        setUserList([])
      }
    } else {
      setToastInfo({
        message: response.message,
        showToast: true,
        role: "error",
      })
    }
  }

  useEffect(() => {
    const bodyData = {
      page: currentPage,
      searchKey: searchValue,
      limit: pageSize,
      columnName: columnId,
      sortingOrder: sortingOrderStatus,
      filterType: filters,
    }

    getUserList(bodyData)
  }, [
    searchValue,
    pageSize,
    columnId,
    sortingOrderStatus,
    currentPage,
    filters,
  ])

  const handlePageChange = (page, pageSize) => {
    setPageSize(pageSize)
    setCurrentPage(page)
  }

  const handleSortColumn = option => {
    if (option.column === "roleName" || option.column === "region") {
      return
    }
    setSortingOptions(option)
    const columnName = option.column
    setColumnId(columnName)
    const sortingOrder = option.isAsc ? "asc" : "desc"
    setSortingOrderStatus(sortingOrder)
  }

  const handleSearchFilter = value => {
    setSearchValue(value)
  }

  const handleClearSearch = () => {
    setSearchValue("")
    setFilters({})
  }

  const customeFilterSection = (
    <div className="text-sm-start">
      <select
        className="form-select  me-3 show-dropdown"
        style={{ width: "150px" }}
        value={filters.isActive}
        onChange={e => {
          const value = e.target.value
          setFilters({ ...filters, isActive: value })
        }}
      >
        <option selected={filters.isActive == ""} value={""}>
          All
        </option>
        <option selected={filters.isActive == 1} value={1}>
          Active
        </option>
        <option selected={filters.isActive == 0} value={0}>
          Inactive
        </option>
      </select>
    </div>
  )

  const buttonSection = (
    <div className="text-sm-end">
      <Button
        type="button"
        color="success"
        className="btn-rounded mb-2 me-2"
        onClick={() => navigate(`/${userRoleName}/users/add`)}
      >
        <i className="mdi mdi-plus me-1" />
        Add User
      </Button>
      {uploadPermission && (
        <Button
          type="button"
          color="success"
          className="btn-rounded mb-2 me-2"
          onClick={() => {
            navigate(`/${userRoleName}/uploadBulkUser/`)
          }}
        >
          <i className="bx bx-folder me-2"></i> Upload Users
        </Button>
      )}
    </div>
  )

  const handleChange = data => {
    const message = "Are you sure want to update user?"
    setShowCommonDialog({ isShow: true, message, data })
  }

  const dialogAction = (action, data) => {
    if (action == 1) {
      setShowCommonDialog({ isShow: false })
      editUserStatus(data)
        .then(response => {
          if (response.code == 201 && response.status) {
            setToastInfo({
              message: "User Status Updated",
              showToast: true,
              role: "success",
            })
          } else {
            const { message } = response
            setToastInfo({
              message: message,
              showToast: true,
              role: "error",
            })
          }
        })
        .catch(error => {
          console.log(error)
        })
    } else {
      setShowCommonDialog({ isShow: false })
      const bodyData = {
        page: currentPage,
        searchKey: searchValue,
        limit: pageSize,
        columnName: columnId,
        sortingOrder: sortingOrderStatus,
      }

      getUserList(bodyData)
    }
  }

  const checkPermissions = async () => {
    const isUploadPermission = await isPermission(
      "bulk_upload_users",
      "upload_permission"
    )
    setUploadPermission(isUploadPermission)
  }
  return (
    <React.Fragment>
      <DeleteModal
        show={!isEmpty(deleteModalInfo)}
        onDeleteClick={deleteUser}
        onCloseClick={() => setDeleteModalInfo({})}
      />
      <div className="page-content">
        <Container fluid>
          <div className="page-title-box d-flex gap-3 justify-content-between align-items-center">
            <h4 className="mb-sm-0 font-size-18">Users List</h4>
            <div className="d-flex gap-3 justify-content-end"></div>
          </div>
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <TableContainerV1
                    columns={columns}
                    data={userList}
                    pagination={pagination}
                    handlePageChange={handlePageChange}
                    customFilterSection={customeFilterSection}
                    handleSearchFilter={handleSearchFilter}
                    searchHelperText="Search by Name, Id, Email, Mobile Number"
                    sortOptions={sortingOptions}
                    customSection={buttonSection}
                    handleSortColumn={handleSortColumn}
                    handleClearSearch={handleClearSearch}
                    className="custom-header-css"
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      {showCommonDialog && (
        <CommonDialog
          isShow={showCommonDialog.isShow}
          message={showCommonDialog.message}
          data={showCommonDialog.data}
          postitiveBtn={"Submit"}
          negativeBtn={"Close"}
          onCloseFn={dialogAction}
        />
      )}
      <ToastDialog
        message={toastInfo.message}
        showToast={toastInfo.showToast}
        role={toastInfo.role}
        onCloseFn={() => setToastInfo({ showToast: false })}
      />
    </React.Fragment>
  )
}

UamUsers.propTypes = {
  customers: PropTypes.array,
  onGetCustomers: PropTypes.func,
  onAddNewCustomer: PropTypes.func,
  onDeleteCustomer: PropTypes.func,
  onUpdateCustomer: PropTypes.func,
}

export default UamUsers
